import { TreeGridColumn } from "../../types"

export const makeColumnLayout = <Column extends TreeGridColumn>({
  LeftCols,
  Cols,
  RightCols,
}: MakeColumnLayoutProps<Column>) => {
  const hasVisibleGanttColumn = RightCols.some(isVisibleGanttColumn)

  if (!hasVisibleGanttColumn) {
    return {
      Cols: [...LeftCols, ...Cols, ...RightCols],
    }
  }

  return {
    LeftCols,
    Cols,
    RightCols,
  }
}

const isVisibleGanttColumn = (column: TreeGridColumn) => {
  return isGanttColumn(column) && column.Visible !== 0 && column.Visible !== false
}

const isGanttColumn = (column: TreeGridColumn) => {
  return column.Name === "Gantt" || column.Type === "Gantt"
}

type MakeColumnLayoutProps<Column extends TreeGridColumn> = {
  LeftCols: Column[]
  Cols: Column[]
  RightCols: Column[]
}
